export const colors = {
    TIME_WRONG:  '#f3787a',
    TIME_OK: '#52b848',
    TIME_SATURDAY: '#fff2c6', 
    TIME_SUNDAY: '#fee67a',
    NONE: 'none',
    HOLIDAYS: '#e0dddb',
}

export const colorsEvent = [
    "#ffcbcb",
    "#ffe8cb",
    "#fff2cb",
    "#ecffcb",
    "#cbffe7",
    "#cfcbff",
    "#d3d3d3",
    "#facda2",
    "#e4ceed",
    "#e9cbff",
    "#cbe1ff",
    "#ffe7cb",
]; 

export const colorsLeave = [
    "#93b0d2",
];